import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import NewTheme from '../components/admin-dashboard/NewTheme';
import axioInstance from "../components/axiosInstance";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function RiskMasterAdmin() {
    let navigate = useNavigate();

    useEffect(() => {
        const loggedInUser = sessionStorage.getItem("admin_id");
        console.log(loggedInUser);
        if (loggedInUser === null) {
            navigate("/ulogin");
        }
    }, [navigate]);

    const [showForm, setShowForm] = useState(false);
    const [risks, setRisks] = useState([]);
    const [editingRisk, setEditingRisk] = useState(null);
    const [formData, setFormData] = useState({
        description: "",
        risk_text: "",
        suggested_approach: [],
        what_this_means: []
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        let res = await axioInstance.get("/risk-master");
        // Parse JSON fields for frontend
        const parsed = res.data.map(r => ({
            ...r,
            suggested_approach: r.suggested_approach ? JSON.parse(r.suggested_approach) : [],
            what_this_means: r.what_this_means ? JSON.parse(r.what_this_means) : []
        }));
        setRisks(parsed);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleArrayChange = (field, index, value) => {
        const updated = [...formData[field]];
        updated[index] = value;
        setFormData({ ...formData, [field]: updated });
    };

    const addArrayItem = (field) => {
        setFormData({ ...formData, [field]: [...formData[field], ""] });
    };

    const handleSubmit = async () => {
        if (editingRisk) {
            await axioInstance.put(`/risk-master/${editingRisk.risk_id}`, formData);
        } else {
            await axioInstance.post("/risk-master", formData);
        }
        fetchData();
        resetForm();
        setShowForm(false);
    };

    const handleEdit = (risk) => {
        setEditingRisk(risk);
        setFormData({
            description: risk.description,
            risk_text: risk.risk_text,
            suggested_approach: risk.suggested_approach || [],
            what_this_means: risk.what_this_means || []
        });
        setShowForm(true);
    };

    const resetForm = () => {
        setEditingRisk(null);
        setFormData({ description: "", risk_text: "", suggested_approach: [], what_this_means: [] });
        setShowForm(false);
    };

    // Add this helper
    const removeArrayItem = (field, index) => {
        const updated = [...formData[field]];
        updated.splice(index, 1); // remove at index
        setFormData({ ...formData, [field]: updated });
    };

    // Define minimal toolbar options
    const modules = {
        toolbar: [
            ["bold", "italic", "underline"],  // basic formatting
            [{ list: "ordered" }, { list: "bullet" }], // lists
            [{ header: [1, 2, false] }],      // small headers
            ["clean"],                        // remove formatting
        ],
    };

    return (
        <>
            <NewTheme>
                <div className="page-header">
                    <div className="content-page-header">
                        <h5>Risk Master Management</h5>
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-12 mb35">
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-center">
                                    <div className="col">
                                        <h5 className="card-title">Risk Master View</h5>
                                    </div>

                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 import_logic" id="import_logic">


                                        <div className="p-6">


                                            <div className="table-responsive mt-3">
                                                <table className="table table-stripped table-hover">
                                                    <thead>
                                                        <tr className="bg-gray-100">
                                                            <th className="p-2 border">Actions</th>
                                                            <th className="p-2 border">Description</th>
                                                            <th className="p-2 border">Risk Text</th>
                                                            <th className="p-2 border">Suggested Approach</th>
                                                            <th className="p-2 border">What This Means</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {risks.map((r) => (<>
                                                            <tr key={r.risk_id}>
                                                                <td className="border p-2">
                                                                    <button className="btn-primary mr-3" onClick={() => handleEdit(r)}>Edit</button>
                                                                </td>
                                                                <td className="border p-2">{r.description}</td>
                                                                <td className="border p-2"><p>{r.risk_text}</p></td>
                                                                <td className="border p-2">
                                                                    <ul>{r.suggested_approach.map((s, i) => <li key={i}>{s}</li>)}</ul>
                                                                </td>
                                                                <td className="border p-2">
                                                                    <ul>{r.what_this_means.map((m, i) => <li key={i}>{m}</li>)}</ul>
                                                                </td>

                                                            </tr>
                                                        </>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <br /><br />

                                            {/* Form */}

                                            {
                                                showForm && (
                                                    <>
                                                        <div className="p-4 border rounded">
                                                            <h3 className="text-lg font-bold mb-2">{editingRisk ? "Edit Risk" : "Add Risk"}</h3>

                                                            <input
                                                                type="text"
                                                                name="description"
                                                                value={formData.description}
                                                                onChange={handleChange}
                                                                placeholder="Description"
                                                                className="form-control"
                                                            /><br />

                                                            <ReactQuill
                                                                theme="snow"
                                                                value={formData.risk_text}
                                                                modules={modules}
                                                                onChange={handleChangeText => setFormData({ ...formData, risk_text: handleChangeText })}
                                                                placeholder="Risk Text"
                                                            />

                                                            {/* Suggested Approach */}
                                                            <h4 className="font-semibold mt30">Suggested Approach</h4>
                                                            <hr />
                                                            {formData.suggested_approach.map((item, i) => (<>
                                                                <div key={i} className="d-flex align-items-center mb-2">
                                                                    <input
                                                                        key={i}
                                                                        type="text"
                                                                        value={item}
                                                                        onChange={(e) => handleArrayChange("suggested_approach", i, e.target.value)}
                                                                        placeholder={`Approach ${i + 1}`}
                                                                        className="form-control"
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger ml-2"
                                                                        onClick={() => removeArrayItem("suggested_approach", i)}
                                                                    >
                                                                        <i class="fa fa-remove"></i>
                                                                    </button>
                                                                    <br />
                                                                </div>
                                                            </>
                                                            ))}
                                                            <button onClick={() => addArrayItem("suggested_approach")} className="btn-primary">+ Add Approach</button>

                                                            {/* What This Means */}
                                                            <h4 className="font-semibold mt50">What This Means</h4>
                                                            <hr />
                                                            {formData.what_this_means.map((item, i) => (<>
                                                                <div key={i} className="d-flex align-items-center mb-2">
                                                                    <input
                                                                        key={i}
                                                                        type="text"
                                                                        value={item}
                                                                        onChange={(e) => handleArrayChange("what_this_means", i, e.target.value)}
                                                                        placeholder={`Meaning ${i + 1}`}
                                                                        className="form-control"
                                                                    /><button
                                                                        type="button"
                                                                        className="btn btn-danger ml-2"
                                                                        onClick={() => removeArrayItem("what_this_means", i)}
                                                                    >
                                                                        <i class="fa fa-remove"></i>
                                                                    </button>
                                                                    <br />
                                                                </div>
                                                            </>
                                                            ))}
                                                            <button onClick={() => addArrayItem("what_this_means")} className="btn-primary">+ Add Meaning</button>

                                                            <div className="mt70">
                                                                <button onClick={handleSubmit} className="btn btn-primary">
                                                                    {editingRisk ? "Update" : "Save"}
                                                                </button>
                                                                <button onClick={resetForm} className="ml-2 btn btn-primary">Reset</button>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </NewTheme>
        </>
    );
}